import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { HelpText } from '../../model/helpText.model';

@Component({
    selector: 'preview-help-text-btn',
    templateUrl: './preview-help-text-btn.component.html',
    styleUrl: './preview-help-text-btn.component.scss'
})
export class PreviewHelpTextBtnComponent implements OnInit {
    @Input() helpText!: HelpText;
    @Input() disabled: boolean = false;
    @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

    isOpen: boolean = false;

    constructor() {}

    ngOnInit(): void {
        this.init();
    }

    init() {}

    openMenu() {
        //this.menuTrigger.openMenu();
        this.isOpen = true;
    }

    closeMenu() {
        this.isOpen = false;
        this.menuTrigger.closeMenu();
    }
}
